// import "./update.scss";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { cchapterInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];

// const CourseChapterUpdate = ({ title }) => {
//   // Extracting cchapterId using regular expressions
//   const location = useLocation();
//   const cchapterId = location.pathname.match(
//     /\/update-course-chapter\/(\d+)/
//   )?.[1];

//   // Initializing state
//   // const [file, setFile] = useState(null);
//   const [inputValues, setInputValues] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [soptions, setSoptions] = useState([]);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchCchapter = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/cchapter/${cchapterId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         const status = data.data.status;
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }

//         setInputValues(data.data);
//         // setFile(data.data.logo);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (cchapterId) {
//       fetchCchapter();
//     }
//   }, [cchapterId]);
//   // console.log("quiz in a state:", data);

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("name", inputValues.name);
//     formData.append("subject_id", localStorage.getItem("selected_subject_id"));
//     formData.append("class_id", localStorage.getItem("selected_class_id"));
//     formData.append("status", parseInt(inputValues.status));
//     console.log(formData);
//     // Send formData to the server using an HTTP request to update
//     fetch(`${serverUrl}/upd_cchapter/${cchapterId}`, {
//       method: "PUT",
//       body: formData, // Send the data as form data
//     })
//       .then((response) => {
//         console.log(response);
//         return response.json();
//       })
//       .then((data) => {
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "Something went wrong.");
//           }

//           // setFilteredOptions(options); // Reset available roles

//           // Force the component to rerender with the empty state
//           setTimeout(() => {}, 500); // Adding timeout to allow state change
//         } else {
//           toast.success("Course Chapter updated successfully!");
//           setTimeout(() => {
//             navigate("/teacher/course-chapter");
//           }, 1000);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         // file
//                                     }
//                                     alt=""
//                                     className="itemImg"
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   {cchapterInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                           // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigatecourse-`/class`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/teacher/course-chapter`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default CourseChapterUpdate;
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cchapterInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const CourseChapterUpdate = ({ title }) => {
  const location = useLocation();
  const cchapterId = location.pathname.match(
    /\/update-course-chapter\/(\d+)/
  )?.[1];
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please login first to access this page");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchCchapter = async () => {
      try {
        const response = await fetch(`${serverUrl}/cchapter/${cchapterId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch chapter");
        }
        const data = await response.json();

        setInputValues(data.data);

        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch chapter data");
      }
    };

    if (cchapterId) {
      fetchCchapter();
    }
  }, [cchapterId]);

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("name", inputValues.name);
    formData.append("subject_id", localStorage.getItem("selected_subject_id"));
    formData.append("class_id", localStorage.getItem("selected_class_id"));
    formData.append("status", parseInt(inputValues.status));

    try {
      const response = await fetch(`${serverUrl}/upd_cchapter/${cchapterId}`, {
        method: "PUT",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Course Chapter updated successfully!");
        setTimeout(() => {
          navigate("/teacher/course-chapter");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  const renderSelectField = (field, options, value, onChange) => (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      required
      className="selectInput"
      styles={{
        control: (base) => ({
          ...base,
          minHeight: "46px",
          borderColor: "#e2e8f0",
          "&:hover": { borderColor: "#cbd5e0" },
        }),
        valueContainer: (base) => ({
          ...base,
          padding: "2px 8px",
        }),
        input: (base) => ({
          ...base,
          margin: "0",
          padding: "0",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: "44px",
        }),
      }}
    />
  );

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>

                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {cchapterInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "status" ? (
                              renderSelectField(
                                "status",
                                statusOptions,
                                selectedStatus,
                                handleStatusSelectChange
                              )
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/teacher/course-chapter")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                      >
                        Update Chapter
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default CourseChapterUpdate;
